import { Quantity } from "../../../Components/Form/Quantity";

export const initQuantitySelector = (quantity: number, quantitySelector: Quantity) => {
    if (quantity === 1) {
        quantitySelector.remove();
    } else {
        quantitySelector.min = "1";
        quantitySelector.max = String(quantity);
        quantitySelector.value = String(quantity);
    }
};
